module.exports = __webpack_public_path__ + "static/media/img2.db217bd3.webp";